import React from 'react';
import './Separator.scss';

const Separator: React.FC = () => {
  return <hr />;
};

export default Separator;
